import React, { useEffect, useState } from "react";
import { Button, Input, message, Table } from "antd";
import {
  CloseCircleFilled,
  CheckCircleFilled,
  AuditOutlined,
} from "@ant-design/icons";
import { Scanner } from "@yudiel/react-qr-scanner";
import { orderStatus, shipStatus } from "utility/options/index";
import { apiCheckIn, apiGetOrder, apiPutOrder } from "api/api";

const Scan = () => {
  const [data, setData] = useState(null);
  const [errCode, setErrCode] = useState(0);
  // # 搜尋欄位
  const [fuzzySearch, setFuzzySearch] = useState("");
  // # 顯示表格
  const [dataSource, setDataSource] = useState([]);

  const checkIn = async () => {
    try {
      const res = await apiCheckIn({ secretKey: data });
      setIsSuccess(true);
      message.success("已完成驗票");
    } catch (error) {
      message.error(error?.response?.data?.message);
      setErrCode(error.response.status);
      setIsFail(true);
    } finally {
      setStart(false);
      setData(null);
    }
  };

  // # 取得所有參加者
  const fetchJoiner = async () => {
    try {
      const res = await apiGetOrder({ fuzzySearch });
      console.log("rrr", res);
      const { content } = res.data;
      setDataSource(content);
    } catch (error) {
      message.error(error.response.data.message);
    }
  };

  // # 搜尋參加者
  const handleSearch = (value) => {
    console.log("Search", value);
    setFuzzySearch(value);
  };

  // # 人工簽到
  const signUp = async (record) => {
    try {
      const res = await apiPutOrder({ shipStatus: 2, detailId: record.id });
      message.success("已完成驗票");
    } catch (error) {
      console.log("err", error);
    } finally {
      fetchJoiner();
    }
  };

  useEffect(() => {
    fetchJoiner();
  }, [fuzzySearch]);

  useEffect(() => {
    if (data !== null) checkIn();
  }, [data]);

  // # 開始驗票
  const [start, setStart] = useState(false);
  const [isFail, setIsFail] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const startCheckIn = () => {
    setStart(true);
  };

  // # 表格columns
  const columns = [
    {
      title: "資訊",
      dataIndex: "info",
      key: "info",
      render: (text, record) => {
        return (
          <>
            <p>票號：{record.id}</p>
            <p>姓名：{record.name}</p>
            <p>Email：{record.email}</p>
            <p>電話：{record.phone}</p>
            <p>電影名稱：{record.title}</p>
          </>
        );
      },
    },

    {
      title: "狀態",
      dataIndex: "shipStatus",
      key: "shipStatus",
      width: 110,
      align: "center",
      render: (text, record) => {
        let status_result = orderStatus.find(
          (item) => item.value == record?.status
        );
        let ship__status_result = shipStatus.find((item) => item.value == text);
        return (
          <>
            <div className="mb-4">
              <p className="bg-black text-white rounded-md">票券狀態</p>
              <p className="font-bold">{status_result?.label}</p>
            </div>
            <div>
              <p className="bg-black text-white rounded-md">簽到狀態</p>
              <p className="font-bold">{ship__status_result?.label}</p>
              {record?.shipStatus == 1 && (
                <Button
                  type="primary"
                  icon={<AuditOutlined />}
                  onClick={(result) => setData(record?.secretKey)}
                  className="mt-1"
                >
                  簽到
                </Button>
              )}
            </div>
          </>
        );
      },
    },
  ];

  // # 失敗頁面
  const FailPage = () => (
    <div className="text-center">
      <h2>
        <CloseCircleFilled className="text-8xl text-red-900" />
      </h2>
      {errCode == 409 ? <h2>票卷已被登錄過</h2> : <h2>票券為無效QR code</h2>}
      <h2>
        <Button
          className="mt-20 w-full bg-Deep-Blue text-white p-5 h-auto"
          onClick={() => {
            setStart(true);
            setIsFail(false);
          }}
        >
          <h2 className="m-0">重新掃描</h2>
        </Button>
      </h2>
    </div>
  );

  // # 成功頁面
  const SuccessPage = () => (
    <div className="text-center">
      <h2>
        <CheckCircleFilled className="text-8xl text-green-900" />
      </h2>
      <h2>票券有效</h2>
      <h2>
        <Button
          className="mt-20 w-full bg-Deep-Blue text-white p-5 h-auto"
          onClick={() => {
            setStart(true);
            setIsSuccess(false);
          }}
        >
          <h2 className="m-0">繼續掃描</h2>
        </Button>
      </h2>
    </div>
  );

  return (
    <>
      {!start && !isFail && !isSuccess && (
        <Button
          className="mt-40 w-full bg-Deep-Blue text-white padding-5 h-auto"
          onClick={startCheckIn}
        >
          <h1>開始驗票</h1>
        </Button>
      )}

      {start && (
        <div className="md:w-1/2 mx-auto min-h-36">
          <Scanner onScan={(result) => setData(result[0].rawValue)}></Scanner>
        </div>
      )}
      {isSuccess && <SuccessPage />}
      {isFail && <FailPage />}
      <h5 className="mb-2">確認是否已經掃描？</h5>

      <Input.Search
        className=""
        placeholder="姓名 / 電話 / 票號 / email"
        onSearch={handleSearch}
        allowClear={true}
      ></Input.Search>

      {/* 有搜尋才顯示 */}
      {fuzzySearch.length > 0 && (
        <Table columns={columns} dataSource={dataSource}></Table>
      )}
    </>
  );
};

export default Scan;
